/* eslint-disable no-unused-vars */
import { Button, Col, Modal, Radio, Row, Tooltip } from 'antd';
import Axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import CreateMarkerComponent from './CreateMarker';
import DeviceStateComponent from './DeviceState';
import MapOfCameraComponent from './MapOfCamera';
import MarkLocationComponent from './MarkLocation';
import './index.scss';

const INTERVAL_TIME = 60000;

const DashboardPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [cameraTimeRequest, setCameraTimeRequest] = useState(
    new Date().getTime()
  );
  const [gatewayTimeRequest, setGatewayTimeRequest] = useState(
    new Date().getTime()
  );

  const [markers, setMarkers] = useState();
  const [localMarker, setLocalMarker] = useState();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [ipAddress, setIpAddress] = useState('0.0.0.0');
  const [keyMap, setKeyMap] = useState(Math.random());
  const [keyMapMode, setKeyMapMode] = useState(Math.random());
  const [mode, setMode] = useState(
    /**
     * @description: view marker in map
     * @type 0: view camera, 1: view gateway
     */
    0
  );
  const {
    isAuth,
    gatewayStates,
    cameras: cameraPage,
    gateways: gatewayPage,
    notifications,
    userId,
    public_ip,
    namespace,
    updateStateDevices,
    listPlaceByPage,
  } = useSelector((state) => state);

  const [listDevices, setListDevices] = useState({});
  const [internalGateways, setInternalGateways] = useState([]);
  const [listNotifications, setListNotifications] = useState(notifications);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      const reqTime = new Date().getTime();
      let data = {
        deviceType: 'gateway',
        timeRequest: reqTime,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.STATISTIC_DEVICE,
        requestId: reqTime,
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));
      setGatewayTimeRequest(reqTime);
    }
  }, [dispatch, isAuth, namespace, keyMap]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      const reqTime = new Date().getTime();
      let data = {
        deviceType: 'camera',
        timeRequest: reqTime,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.STATISTIC_DEVICE,
        requestId: reqTime,
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));
      setCameraTimeRequest(reqTime);
    }
  }, [dispatch, isAuth, namespace, keyMap]);

  useEffect(() => {
    let requestIntervalCameraId = null;
    if (isAuth === 1 && namespace) {
      const reqTime = new Date().getTime();
      let data = {
        deviceType: 'camera',
        timeRequest: reqTime,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.STATISTIC_DEVICE_STATUS,
        requestId: reqTime,
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));

      requestIntervalCameraId = setInterval(() => {
        dispatch(socketEmitEvent(dataObj));
      }, INTERVAL_TIME);
    }
    return () => {
      if (requestIntervalCameraId) {
        clearInterval(requestIntervalCameraId);
      }
    };
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    let requestIntervalGatewayId = null;
    if (isAuth === 1 && namespace) {
      const reqTime = new Date().getTime();
      let data = {
        deviceType: 'gateway',
        timeRequest: reqTime,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.STATISTIC_DEVICE_STATUS,
        requestId: reqTime,
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));

      requestIntervalGatewayId = setInterval(() => {
        dispatch(socketEmitEvent(dataObj));
      }, INTERVAL_TIME);
    }
    return () => {
      if (requestIntervalGatewayId) {
        clearInterval(requestIntervalGatewayId);
      }
    };
  }, [dispatch, isAuth, namespace]);

  const getDeviceStatesMap = useCallback(
    (deviceSerials) => {
      let data = {
        namespace,
        serials: deviceSerials.join(';'),
      };

      let dataObj = {
        appServiceType: SERVICE.LIST_STATE_DEVICES,
        requestId: 1646116091999,
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, namespace]
  );

  useEffect(() => {
    if (cameraPage) {
      setListDevices((state) => ({
        ...state,
        cameras: cameraPage.data,
      }));

      let gatewaySerials = [
        ...new Set(cameraPage.data?.map((item) => item.gatewaySerial)),
      ];

      if (gatewaySerials.length > 0) {
      } else {
        setInternalGateways([]);
      }
    }
  }, [cameraPage]);

  useEffect(() => {
    if (gatewayPage) {
      setListDevices((state) => ({
        ...state,
        gateways: gatewayPage.data,
      }));
    }
  }, [gatewayPage]);

  useEffect(() => {
    async function getInternalGateway(link, serial) {
      try {
        let result = await Axios.get(link);
        return result.status === 200 && result.data.serial === serial;
      } catch (error) {
        return false;
      }
    }

    if (
      gatewayStates &&
      gatewayStates.requestId === cameraTimeRequest &&
      ipAddress
    ) {
      setInternalGateways(
        gatewayStates.data.filter((gateway) => {
          if (
            ipAddress &&
            gateway.state === 1 &&
            gateway.ipAddress &&
            gateway.ipAddress === ipAddress &&
            gateway.localAddress &&
            gateway.localAddress.length > 0
          ) {
            return getInternalGateway(
              `http://${gateway.localAddress}:${gateway.portScan}/info`,
              gateway.serial
            );
          }
          return false;
        })
      );
    }
  }, [cameraTimeRequest, gatewayStates, ipAddress]);

  useEffect(() => {
    if (notifications) {
      setListNotifications(notifications);
    }
  }, [notifications]);

  useEffect(() => {
    if (listPlaceByPage?.places?.length >= 0) {
      setMarkers(
        listPlaceByPage?.places?.map((item) => ({
          name: item?.name,
          location: item?.address ?? '',
          lat: item?.lat,
          lng: item?.lng,
          key: item?.placeId,
        }))
      );
    }
  }, [listPlaceByPage]);

  const onCreateMarker = useCallback(
    (values) => {
      const { name, location, lat, lng } = values;

      let marks = markers.concat({
        name,
        location,
        lat,
        lng,
        key: new Date().getTime() + lat,
      });

      setLocalMarker({ lat, lng });
      setVisibleAdd(false);

      let data = {
        namespace,
        name: name ?? '',
        lat: lat ?? 0,
        lng: lng ?? 0,
        type: 'place-camera',
        address: location ?? '',
        configuration: '',
      };
      let dataObj = {
        appServiceType: SERVICE.ADD_PLACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [dispatch, markers, namespace]
  );

  const onRemoveMarker = (key) => {
    let data = markers.filter((mark) => mark.key !== key);
    let save = {
      userId,
      marks: data,
    };

    let dataPlace = {
      placeId: key,
      namespace,
    };
    let dataObjPlace = {
      appServiceType: SERVICE.REMOVE_PLACE,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataPlace),
    };
    return dispatch(socketEmitEvent(dataObjPlace));
  };

  const getListAtmPlaceByPage = useCallback(
    (page, size, searchName, tag) => {
      let data = {
        appServiceType: SERVICE.LIST_ALL_PLACE_BY_PAGE,
        requestId: new Date().getTime(),
        body: JSON.stringify({
          ...(searchName && { name: searchName }),
          ...(tag && { tag }),
          namespace,
          locationType: 'place-camera',
          timeRequest: new Date().getTime(),
          page: page ?? 0,
          size: size ?? 100,
        }),
      };
      return dispatch(socketEmitEvent(data));
    },
    [dispatch, namespace]
  );

  useEffect(() => {
    if (namespace) {
      getListAtmPlaceByPage();
    }
  }, [getListAtmPlaceByPage, namespace]);

  return (
    <div className="homepage-component">
      <Modal
        forceRender
        visible={visibleAdd}
        title={t('Create a quick access location')}
        onCancel={() => setVisibleAdd(false)}
        footer={null}
      >
        {visibleAdd && (
          <CreateMarkerComponent onCreateMarker={onCreateMarker} />
        )}
      </Modal>
      <Row>
        <Col key={keyMapMode} flex="auto">
          <MapOfCameraComponent
            key={keyMap}
            localMarker={localMarker}
            mode={mode}
            cameras={listDevices && listDevices.cameras}
            gateways={listDevices && listDevices.gateways}
            internalGateways={internalGateways}
            getDeviceStatesMap={getDeviceStatesMap}
            setKeyMap={setKeyMap}
            setMode={setMode}
          />
        </Col>
        <Col flex="300px">
          <div className="info-component">
            <div className="home-top-component">
              <div className="tab-child">
                <MarkLocationComponent
                  onView={(lat, lng) => setLocalMarker({ lat, lng })}
                  onRemove={onRemoveMarker}
                  data={markers}
                  onCreate={() => setVisibleAdd(true)}
                />
                {markers && markers.length > 0 && (
                  <div className="button-add">
                    <Button onClick={() => setVisibleAdd(true)}>
                      {t('Create location')}
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div className="switch-mode-marker">
              <Radio.Group
                size="large"
                onChange={(event) => {
                  setMode(event.target.value);
                  setKeyMapMode(Math.random());
                }}
                value={mode}
              >
                <Tooltip title={t('Toggle view cameras')}>
                  <Radio className="switch" value={0}>
                    {t('Camera')}
                  </Radio>
                </Tooltip>
                <Tooltip title={t('Toggle view gateway')}>
                  <Radio className="switch" value={1}>
                    {t('Gateway')}
                  </Radio>
                </Tooltip>
              </Radio.Group>
            </div>
            <DeviceStateComponent
              mode={mode}
              data={mode === 0 ? cameraPage : gatewayPage}
            />
          </div>
        </Col>
      </Row>
      <div className="map-component"></div>
    </div>
  );
};

export default DashboardPage;
